import { PhoneLocaleOptions } from "./localizedTypes";

// index string is converted to lowercase to make sure
// there are no differences in the way it's passed from outside of the component
export const localeOptions: Partial<PhoneLocaleOptions> = {
  "en-US": {
    placeholder: "(###) ###-####",
    format: "(###) ###-####",
    countryCode: "+1",
    localizationString: "United States (English)",
  },
  "en-AU": {
    placeholder: "0XXX XXX XXX",
    format: "0# #### ####",
    countryCode: "+61",
    minimumLength: 10,
    numberPrefix: "0",
    localizationString: "Australia (English)",
  },
};
